import Vue from "vue";
import RouterUtils from "@/utils/RouterUtils";
import Store from "./services/store";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import system from "./modules/system/module";

import IdentityManager from "@arcgis/core/identity/IdentityManager";
import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import Portal from "@arcgis/core/portal/Portal";
import esriConfig from "@arcgis/core/config";
import "@arcgis/core/assets/esri/themes/light/main.css";
import {ApolloClient} from "apollo-client";
import {createHttpLink} from "apollo-link-http";
import {InMemoryCache} from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";
import VueRouter from "vue-router";
import VueGtm from "@gtm-support/vue2-gtm";
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

Store.registerModule("system", system.store);
Store.dispatch("system/initialize", null, {root: true});

Vue.use(VueRouter);
const Router = RouterUtils.createRouter(Store.state.system.routes);

Vue.use(VueGtm, {
    id: "GTM-KMQXLJQ3B9",
    defer: false,
    debug: true,
    vueRouter: Router,
    loadScript: false,
    trackOnNextTick: false,
});

Vue.use(VuetifyDialog, {
    context: {
        vuetify
    }
})

Vue.config.productionTip = false;
const appId =
    "XlsTWaHKeBeqDxMT"; /* https://gis.msu.edu/portal/home/item.html?id=376ae73cd9b546e0b1475802b715698a */
const portalUrl = "https://gis.msu.edu/portal";

esriConfig.portalUrl = portalUrl;
const info = new OAuthInfo({
    appId: appId,
    portalUrl: portalUrl,
    popup: false,
});
const esriId = IdentityManager;
esriId.registerOAuthInfos([info]);

const apiHttpLink = createHttpLink({
    uri: "https://api.gis.msu.edu/graphql",
});
const apiCache = new InMemoryCache({
    freezeResults: true,
});
const apolloClient = new ApolloClient({
    link: apiHttpLink,
    cache: apiCache,
});
const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});
Vue.use(VueApollo);

const portal = new Portal({
    url: portalUrl,
    authMode: "auto",
});
portal.load().then(function () {
    new Vue({
        router: Router,
        store: Store,
        vuetify,
        apolloProvider,
        render: (h) => h(App),
    }).$mount("#app");

    Vue.filter("toCurrency", function (value) {
        if (typeof value === "string" && !isNaN(parseFloat(value))) {
            value = parseFloat(value);
        }
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        return formatter.format(value);
    });

    Vue.filter("toNumber", function (value) {
        if (typeof value === "string" && !isNaN(parseFloat(value))) {
            value = parseFloat(value);
        }
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        return formatter.format(value);
    });

    Vue.filter("toProperCase", function (value) {
        return value.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    });
});
